<div class="val-facture-achat-page-conteneur val-flex-conteneur val-flex-colonne val-flex-center-vertical">
  
  <div class="val-facture-achat-page-entete val-flex-conteneur">
    <val-simple-libelle class="val-facture-achat-page-titre val-flex-1" 
      [libelle]="titre()"></val-simple-libelle>
    <div>
      <val-barre-menus [menuItems]="menuItems()"></val-barre-menus>
    </div>
  </div>

  <div class="val-facture-achat-page-contenu val-flex-1">
    @if (initialisationTermine$ | async) {
      <val-facture-achat-fiche-contenu #ficheContenu></val-facture-achat-fiche-contenu>
    }
  </div>

</div>
